import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const raisons = [
  "Confort quotidien : ouvrez et fermez vos volets sans effort",
  "Programmation horaire : automatisez les heures d'ouverture et fermeture",
  "Pilotage à distance : télécommande, smartphone ou commande vocale",
  "Sécurité renforcée : simulation de présence lors de vos absences",
  "Motorisation silencieuse : moteurs Somfy à couple adapté et discret",
  "Compatibilité domotique : intégration avec vos autres équipements connectés",
];

export default function Pourquoi() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Pourquoi <strong className="text-brand-blue">motoriser</strong> avec Somfy
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              La <strong className="text-brand-blue">motorisation Somfy</strong> transforme votre quotidien. Plus besoin de manipuler manuellement chaque volet : un simple appui sur une télécommande, une programmation horaire ou une commande vocale suffit pour piloter l'ensemble de vos ouvrants. Nos techniciens à Strasbourg et dans le <a href="/zones-d-intervention" className="text-brand-cyan hover:underline">Bas-Rhin</a> posent des motorisations Somfy sur volets existants et neufs, en adaptant le couple moteur au poids et aux dimensions de votre tablier.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Somfy propose plusieurs gammes de motorisation : filaire pour une installation simple et économique, radio RTS pour une pose sans travaux de gros œuvre, et io-homecontrol pour une intégration domotique complète. Nous vous guidons dans le choix du moteur et des commandes en fonction de votre usage, de votre budget et de votre équipement existant. Chaque installation est réalisée avec soin, réglée et testée pour un fonctionnement fluide et silencieux.
            </p>
            <ul className="space-y-3 mb-8">
              {raisons.map((raison) => (
                <li key={raison} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{raison}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap mx-auto"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Modern%20French%20living%20room%20with%20motorized%20white%20roller%20shutters%20controlled%20by%20a%20remote%20from%20a%20comfortable%20sofa%20warm%20interior%20lighting%20cozy%20atmosphere%20clean%20professional%20photography%20neutral%20tones%20Alsace%20home&width=700&height=520&seq=moto-pourq&orientation=landscape" alt="Salon avec volets Somfy motorisés commandés à distance" className="w-full h-[340px] md:h-[420px]" loading="lazy" width={700} height={520} />
          </div>
        </div>
      </div>
    </section>
  );
}